
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 54","fill":"inherit","stroke":"#888787","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 12H4.5A2.507 2.507 0 002 14.5v35C2 50.875 3.125 52 4.5 52h35c1.375 0 2.5-1.125 2.5-2.5V42H14.5a2.507 2.507 0 01-2.5-2.5V12z","fill":"none","stroke":"inherit","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M49.5 42h-35a2.507 2.507 0 01-2.5-2.5v-35C12 3.125 13.125 2 14.5 2h26.475c.675 0 1.3.275 1.775.725l8.525 8.525c.45.475.725 1.125.725 1.775V39.5c0 1.375-1.125 2.5-2.5 2.5zM42 32H22M22 22h20M22 12h7.5","fill":"none","stroke":"inherit","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.5 2v12.5H52v-1.475c0-.65-.275-1.3-.725-1.75l-8.55-8.55c-.45-.45-1.1-.725-1.75-.725H39.5z","fill":"none","stroke":"inherit","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    